import { Spin, Modal } from 'antd';
import React, { useState } from 'react';
import { addLearner } from '../../services/learnerService';
import LearnerForm from './LearnerForm';

function LearnerAdd(props) {
  const initialValues = {
    email: '',
    firstName: '',
    lastName: '',
    phoneNumber: '',
    countryId: '',
    profileImage: '',
    description: '',
    address: '',
    additionalAddress: '',
    city: '',
    postalCode: '',
    laptop: '',
    camera: '',
    editingSoftware: '',
  };

  const [status, setStatus] = useState({
    type: 'IDLE',
    message: 'In idle mode',
  });

  async function onSubmit(values) {
    setStatus({ type: 'LOADING', message: 'Request in Progress!' });

    const updatedValues = {
      email: values.email,
      firstName: values.firstName,
      lastName: values.lastName,
      phoneNumber: values.phoneNumber,
      countryId: values.countryId,
      profileImage: values.profileImage,
      description: values.description,
      address: {
        address: values.address,
        additionalAddress: values.additionalAddress,
        city: values.city,
        postalCode: values.postalCode,
      },
      extraInfo: {
        laptop: {
          type: values.laptop,
          hasItem: !!values.laptop,
        },
        editingSoftware: {
          type: values.editingSoftware,
          hasItem: !!values.editingSoftware,
        },
        camera: {
          type: values.camera,
          hasItem: !!values.camera,
        },
      },
    };

    await addLearner(updatedValues)
      .then((response) => {
        console.log('Successfully Added! ', response);
        setStatus({ type: 'SUCCESS', message: 'Data added successfully!' });
      })
      .catch((error) => {
        alert('Getting data from the backend failed!');
        if (error?.response?.data?.message)
          setStatus({ type: 'ERROR', message: error.response.data.message });
        else setStatus({ type: 'ERROR', message: 'Something went wrong!' });
      });
  }

  return (
    <Modal
      title={`Add Learner`}
      visible={props.isOpen}
      onCancel={() => props.toggle()}
      footer={null}
    >
      {status.type === 'LOADING' ? (
        <Spin size="large" />
      ) : (
        <LearnerForm
          type="Add"
          initialValues={initialValues}
          onSubmit={onSubmit}
          status={status}
        />
      )}
    </Modal>
  );
}

export default LearnerAdd;
